import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { ModalService } from 'ui-components/services/modal-service';
import { LabelBatchStatusModal } from '../../../../../components/modals/label-batch-status';
import { LabelBatchStatusStep } from '../../../../../enums/label-batch-status-step';
import { LabelBatchProcessingModalContainer } from '../../../../../components/modals/label-batch-status/processing/modal-container';
import Global from '../../../../../store/global-selectors';
import { goToOrderDetails } from '../../../../../store/orders/order-details/orders.details.actions';
import { getLabelQueBatchesRequest } from '../../../../../store/label-que/label-que.actions';
import { addLabelBatchStatusModalBatch } from '../../../../../store/batches/label-batch-status-modal/batches.label-batch-status-modal.actions';

import style from '../style.module.less';

export const openLabelBatchStatusModal = (batchId) => {
  ModalService.launchModal({
    component: LabelBatchStatusModal,
    props: {
      step: LabelBatchStatusStep.Processing.ordinal,
      StepComponent: LabelBatchProcessingModalContainer,
      batchId,
      batchIds: [batchId],
    },
  });
};

const OrderOrBatchNumber = ({ batchId = '' }) => {
  const dispatch = useDispatch();

  const stringBatchId = batchId.toString();
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const batches = useSelector(Global.selectLabelQueBatches) || [];
  const batch = useMemo(
    () => batches.find((findBatch) => findBatch.batchId.toString() === stringBatchId) || {},
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- batches changes every render
    [batches, stringBatchId],
  );
  const { batchNumber, fulfillmentPlanId, customerName } = batch;
  const [salesOrderId] =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId: parseInt(fulfillmentPlanId, 10),
        property: 'salesOrdersFulfilledIds',
      }),
    ) || [];

  const openOrderDetailsModal = useCallback(
    (props) => {
      dispatch(goToOrderDetails(props));
    },
    [dispatch],
  );
  const refreshQue = useCallback(() => {
    dispatch(getLabelQueBatchesRequest());
    dispatch(addLabelBatchStatusModalBatch(batch));
  }, [dispatch, batch]);

  const onTitleClick = useCallback(() => {
    if (salesOrderId) {
      openOrderDetailsModal({ salesOrderId, fulfillmentPlanId });
      return;
    }
    refreshQue();
    openLabelBatchStatusModal(stringBatchId);
  }, [fulfillmentPlanId, stringBatchId, openOrderDetailsModal, refreshQue, salesOrderId]);

  return (
    <Button className={style['header-number-button']} onClick={onTitleClick} theme='unstyled'>
      {customerName && !batchNumber && (customerName || '')}
      {!(customerName && !batchNumber) &&
        (fulfillmentPlanId ? (
          <FormattedMessage
            defaultMessage='Order #{batchNumber}'
            description='batchTileHeader.order'
            id='Q7799E'
            values={{ batchNumber }}
          />
        ) : (
          <FormattedMessage
            defaultMessage='Batch: {batchNumber}'
            description='batchTileHeader.batch'
            id='drJdYV'
            values={{ batchNumber }}
          />
        ))}
    </Button>
  );
};

OrderOrBatchNumber.propTypes = {
  batchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default OrderOrBatchNumber;
